import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sessionId) return;
    let mounted = true;
    const check = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (!mounted) return;
        setStatus(r.data);
        if (r.data.payment_status === "paid") { refresh(); return; }
      } catch (e) { console.error("payment status check failed", e); }
      setTries((n) => n + 1);
    };
    check();
    const t = setInterval(() => {
      if (status?.payment_status === "paid" || tries > 15) return;
      check();
    }, 2000);
    return () => { mounted = false; clearInterval(t); };
  }, [sessionId, tries, status, refresh]);

  const paid = status?.payment_status === "paid";
  return (
    <div className="max-w-xl mx-auto mt-16 text-center">
      <div className="rs-underline mx-auto mb-6" />
      {paid ? (
        <>
          <h1 data-testid="payment-success-title" className="font-display-heavy text-5xl text-green-500">PAYMENT CONFIRMED</h1>
          <p className="text-neutral-300 mt-4">Your account has been updated.</p>
          <div className="mt-8 flex justify-center gap-3">
            <Link to="/dashboard"><Button className="h-12 px-6 bg-red-600 hover:bg-red-700 font-semibold">Go to dashboard</Button></Link>
            <Link to="/upload"><Button variant="outline" className="h-12 px-6 border-neutral-700 text-white hover:bg-neutral-900">Start an analysis</Button></Link>
          </div>
        </>
      ) : (
        <>
          <h1 className="font-display-heavy text-4xl">CONFIRMING PAYMENT…</h1>
          <div className="mx-auto mt-6 w-12 h-12 border-4 border-red-600 border-t-transparent rounded-full animate-spin" />
          <p className="text-neutral-400 mt-4">This usually takes a few seconds.</p>
        </>
      )}
    </div>
  );
}
